import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaperCard from '../components/PaperCard';
import Loading from '../components/Loading';
import ErrorMessage from '../components/ErrorMessage';
import { API_V1, apiGet } from '../lib/api';

const API = `${API_V1}/digests`;

// 将日期列表按「年月」分组，用于侧边栏折叠展示
function groupByMonth(dates) {
  const groups = {};
  for (const d of dates) {
    const ym = d.slice(0, 7); // YYYY-MM
    (groups[ym] = groups[ym] || []).push(d);
  }
  return Object.entries(groups)
    .sort((a, b) => (a[0] < b[0] ? 1 : -1))
    .map(([ym, ds]) => ({ ym, dates: ds }));
}

export default function RecommendationsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dates, setDates] = useState([]);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [collapsed, setCollapsed] = useState({});

  const activeDate = searchParams.get('date') || '';

  useEffect(() => {
    apiGet(`${API}/dates`)
      .then(d => setDates(d.dates))
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false));
  }, []);

  // 初次进入且无 ?date= 时，默认选中最新日期（replace，不污染历史）
  useEffect(() => {
    if (dates.length > 0 && !activeDate) {
      setSearchParams({ date: dates[0] }, { replace: true });
    }
  }, [dates, activeDate, setSearchParams]);

  useEffect(() => {
    if (!activeDate) return;
    setPapers([]);
    apiGet(`${API}/daily?date=${encodeURIComponent(activeDate)}`)
      .then(d => setPapers(d.papers))
      .catch(e => setErr(e.message));
  }, [activeDate]);

  if (err) return <ErrorMessage message={err} />;
  if (loading) return <Loading />;

  const monthGroups = groupByMonth(dates);

  return (
    <div className="page-with-side">
      <aside className="side-list">
        <div className="side-list-header">每日精选</div>
        {monthGroups.map(g => {
          const isCollapsed = collapsed[g.ym];
          const [y, m] = g.ym.split('-');
          return (
            <div key={g.ym} className="side-group">
              <button className="side-group-title" onClick={() => setCollapsed(p => ({ ...p, [g.ym]: !p[g.ym] }))}>
                <i className={`fas fa-chevron-${isCollapsed ? 'right' : 'down'}`} />
                <span>{y} 年 {parseInt(m)} 月</span>
                <span className="side-group-count">{g.dates.length}</span>
              </button>
              {!isCollapsed && g.dates.map(d => (
                <button
                  key={d}
                  className={`side-date${activeDate === d ? ' active' : ''}`}
                  onClick={() => setSearchParams({ date: d })}
                >
                  {parseInt(d.slice(8, 10))} 日
                </button>
              ))}
            </div>
          );
        })}
      </aside>

      <section className="side-content">
        <header className="content-head">
          <h2>{activeDate} 每日精选</h2>
          <span className="content-sub">{papers.length} 篇解读</span>
        </header>
        {papers.length === 0 ? (
          <div className="empty-hint">该日暂无解读</div>
        ) : (
          <div className="card-grid">
            {papers.map(p => <PaperCard key={p.id} paper={p} navIds={papers.map(x => x.id)} />)}
          </div>
        )}
      </section>
    </div>
  );
}
